import {ACTION_CODE} from './_actionCode';
import {BankService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_BANKS';

export async function getAllBanks(
    userData: UserState["userProfileData"],
    params = "",
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllBanks - Start');

        const getAllBanksResult = await BankService.getAllBanks(userData, params, page);

        LoggerService.logInfo('Action - getAllBanks - End - Success');

        return ResultModel.newSuccessResult(getAllBanksResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllBanks - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des banques.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
